<template>
    <b-button type="submit" :disabled="isSaving" class="akkurate-green-btn text-white btn-size">
        <font-awesome-icon class="me-2" :icon="['fas', 'save']" /> Save
    </b-button>
</template>

<script>
export default {
    props:["isSaving"]
}
</script>